<template>
  <Reveal @onVisibilityChange="handleVisibilityChange" @onCenteredChange="handleCenteredChange">
    <div :class="['dh-psy-reveal', { 'dh-psy-reveal--centered': centered }]" slot="item">
      <!--<Intro :is-intro="false" />-->

      <div>
        <h3 v-if="heading" v-html="heading" />
        <p v-if="!Array.isArray(content)">
          <span class="dh-psy-reveal__text" v-for="(text, idx) in content" :key="idx" v-html="text">
          </span>
        </p>

        <div v-else v-for="(item, idx) in content" :key="idx">
          <div v-if="item.type === 'image'" class="dh-psy-reveal__image">
            <RegularImage :imageId="item.value['id']" :aspect="item.value['aspect']" :reset="true" />
          </div>
          <List :dark="centered" v-else-if="item.type === 'list'" :item="item" />
          <!--<li v-for="(listItem, listIdx) in item.value" :key="listIdx" v-html="listItem.value" />
          </List>-->
          <p v-else v-html="item.value" />
        </div>
      </div>
    </div>
  </Reveal>
</template>

<script>
import Reveal from '../../Utilities/Reveal.vue'
import List from '../../Typography/List.vue'
import RegularImage from '../../Media/Images/Regular.vue'

export default {
  props: {
    content: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      required: false,
      default: 'text'
    },
    heading: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      centered: false,
      center: 0,
      visible: false,
      thresholdTop: 35,
      thresholdBottom: 70
    }
  },
  computed: {},
  methods: {
    handleCenteredChange(e) {
      this.centered = e
    },
    handleVisibilityChange(e) {
      this.visible = e
    }
  },
  components: { Reveal, RegularImage, List }
}
</script>

<style lang="postcss" scoped>
  .dh-psy-reveal {
    font-family: 'NRK Etica Slab';
    font-weight: 300;
    line-height: 1.6;
    font-size: calc(1.1em + 0.1vw);

    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 30vh;
    min-height: calc(30 * var(--dh-vh));

    z-index: 1;

    text-align: left;
    transition: color ease-in-out 500ms;
    max-width: 590px;
    margin: auto;

    & :global(a[href]) {
      color: #14a081;

      &:hover {
        border-bottom: 1px solid #14a081;
      }
    }
    @media (min-width: 700px) {
      max-width: 750px;
      width: 90%;
      min-height: 50vh;
      min-height: calc(50 * var(--dh-vh));

      text-align: left;
    }

    & p,
    & h3 {
      width: 80%;
      margin: 100px auto;
      text-align: center;
      z-index: 1;

      & :global(small) {
        font-family: 'LFT Etica';
        font-size: 0.85em;
      }
    }

    & h3 {
      margin-bottom: 30px;
    }

    & :global(i) {
      font-style: normal;
      font-weight: bold;
    }
  }

  .dh-psy-reveal__image {
    width: 90%;
    max-width: 200px;
    margin: 100px auto;

    @media (min-width: 800px) {
      max-width: 375px;
    }

    & :global(figcaption) {
      font-family: LFT Etica;
    }
  }

  .dh-psy-reveal--centered {
    & :global(i) {
      color: #1bd8ae;
    }

    & :global(a[href]) {
      color: #00d8ad;

      &:hover {
        border-bottom: 1px solid #00d8ad;
      }
    }
  }
</style>
